var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10661_110843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2424 2.07749H16.0596V1.43275H16.2351C16.6313 1.43275 16.9515 1.11181 16.9515 0.716375C16.9515 0.320936 16.6313 0 16.2351 0H4.38844C3.99228 0 3.67206 0.320936 3.67206 0.716375C3.67206 1.11181 3.99228 1.43275 4.38844 1.43275H4.56395V2.07749H2.38187C1.75791 2.07749 1.25 2.5854 1.25 3.20936V3.63202C1.25 5.83201 2.72287 7.68026 4.80537 8.22542C5.28892 9.85947 6.47739 11.2098 8.08851 11.8818V14.2358H12.4555V11.9112C14.0831 11.255 15.311 9.87666 15.8118 8.22685C17.8986 7.68455 19.375 5.83487 19.375 3.6313V3.20936C19.3743 2.5854 18.8664 2.07749 18.2424 2.07749ZM2.68275 3.51024H4.56467V6.5799C4.56467 6.59566 4.56825 6.61071 4.56825 6.62718C3.43853 6.08489 2.68275 4.94872 2.68275 3.63202V3.51024ZM16.0596 6.5799V3.51024H17.9415V3.63202C17.9415 4.94943 17.185 6.08489 16.056 6.62647C16.0568 6.61071 16.0596 6.59566 16.0596 6.5799ZM10.3121 9.26631C9.94822 9.26631 9.61296 9.06859 9.43745 8.74909L9.04201 8.02985C8.87724 7.72897 8.63081 7.48325 8.32993 7.31992L7.60854 6.92735C7.28761 6.75255 7.08774 6.41657 7.08774 6.0505C7.08774 5.68515 7.28689 5.34917 7.60854 5.17438L8.32922 4.7818C8.63081 4.61775 8.87724 4.37204 9.04273 4.07116L9.43673 3.35263C9.61296 3.03313 9.94822 2.83541 10.3121 2.83541C10.6761 2.83541 11.0113 3.03313 11.1868 3.35263L11.5823 4.07187C11.747 4.37204 11.9935 4.61775 12.2951 4.78252L13.0157 5.17438C13.3367 5.34917 13.5365 5.68515 13.5365 6.0505C13.5365 6.41657 13.3374 6.75183 13.0157 6.92735L12.2951 7.31992C11.9935 7.48397 11.747 7.72897 11.5823 8.03056L11.1876 8.74909C11.0113 9.06859 10.6761 9.26631 10.3121 9.26631Z",
    fill: "#FBC34E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10661_110843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09018 14.2363H7.87025C7.08009 14.2363 6.4375 14.8789 6.4375 15.6691V16.4313H14.1901V15.6691C14.1901 14.8789 13.5475 14.2363 12.7574 14.2363H12.4565H8.09018Z",
    fill: "#FFC331"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.43401 16.4307H6.37025C5.58009 16.4307 4.9375 17.0733 4.9375 17.8634V19.342C4.9375 19.7374 5.25772 20.0584 5.65387 20.0584H14.9667C15.3629 20.0584 15.6831 19.7374 15.6831 19.342V17.8634C15.6831 17.0733 15.0405 16.4307 14.2504 16.4307H14.1866H6.43401Z",
    fill: "#FFBD1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7214 9.35569L12.2723 8.46185C12.5023 8.08756 12.8462 7.78189 13.2672 7.57781L14.2731 7.08945C14.721 6.87201 15 6.45405 15 5.99866C15 5.54417 14.722 5.12621 14.2731 4.90877L13.2672 4.4213C12.8462 4.21722 12.5023 3.91155 12.2723 3.53726L11.7204 2.64342C11.4754 2.24596 11.0074 2 10.4995 2C9.99156 2 9.52361 2.24596 9.27764 2.64431L8.7277 3.53815C8.49672 3.91244 8.15276 4.21811 7.73181 4.42219L6.72592 4.91055C6.27797 5.1271 6 5.54506 6 5.99955C6 6.45494 6.27797 6.87201 6.72692 7.09034L7.73381 7.5787C8.15376 7.78278 8.49772 8.08756 8.7277 8.46185L9.27964 9.35658C9.52461 9.75315 9.99256 10 10.5005 10C11.0084 10 11.4754 9.75404 11.7214 9.35569Z",
    fill: "#FBC34E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_10661_110843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4714 2.60479L11.4006 4.37456C11.4251 4.42113 11.474 4.4677 11.5473 4.4677L13.6013 4.74714C13.748 4.77043 13.7969 4.93343 13.6991 5.04986L12.2075 6.42376C12.1586 6.47034 12.1342 6.51691 12.1586 6.58677L12.501 8.54283C12.5254 8.68255 12.3787 8.79898 12.232 8.72912L10.3981 7.79766C10.3492 7.77438 10.2758 7.77438 10.2269 7.79766L8.39301 8.72912C8.27075 8.79898 8.09959 8.68255 8.12404 8.54283L8.46637 6.58677C8.46637 6.54019 8.46637 6.47034 8.41746 6.42376L6.92589 5.04986C6.82808 4.95672 6.87698 4.77043 7.02369 4.74714L9.07767 4.4677C9.12657 4.4677 9.17548 4.42113 9.22438 4.37456L10.1536 2.60479C10.2269 2.46507 10.3981 2.46507 10.4714 2.60479Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 2.5498C10.3431 2.5498 10.3756 2.56322 10.4023 2.59277L10.4268 2.62793L11.3564 4.39746C11.3859 4.45362 11.4471 4.51396 11.541 4.5166V4.51758L13.5938 4.7959V4.79688C13.6483 4.80564 13.6817 4.83894 13.6943 4.87891C13.7067 4.91867 13.6991 4.96866 13.6631 5.01367L12.1738 6.38672L12.1729 6.3877C12.146 6.4133 12.1213 6.44355 12.1084 6.48047C12.0959 6.51643 12.0967 6.55417 12.1094 6.59473V6.5957L12.4521 8.55176C12.4688 8.64837 12.3664 8.73701 12.2539 8.68359H12.2529L10.4209 7.75293H10.4199C10.3873 7.73741 10.3487 7.73047 10.3125 7.73047C10.2945 7.73047 10.2759 7.73175 10.2578 7.73535L10.2051 7.75293H10.2041L8.37012 8.68457L8.36816 8.68555C8.32746 8.7088 8.27455 8.70348 8.23145 8.67383C8.19925 8.65167 8.17813 8.61971 8.17285 8.58594V8.55176L8.51562 6.5957L8.4668 6.58691L8.5166 6.5957V6.58691C8.5166 6.55489 8.51774 6.49442 8.49023 6.43945L8.45215 6.3877L8.45117 6.38672L6.95996 5.0127H6.95898C6.89172 4.94669 6.92782 4.81356 7.03125 4.79688L7.03027 4.7959L9.08398 4.51758L9.08301 4.51562C9.12058 4.51404 9.15352 4.49813 9.17969 4.47949L9.25879 4.41113L9.26465 4.40527L9.26855 4.39746L10.1982 2.62793C10.2271 2.57316 10.2717 2.5498 10.3125 2.5498Z",
    stroke: "#FFE065",
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10661_110843",
    x: 2.4375,
    y: 14.2363,
    width: 15.75,
    height: 10.1953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.980392 0 0 0 0 0.858824 0 0 0 0 0.0784314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10661_110843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10661_110843",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_10661_110843",
    x: 6.875,
    y: 2.5,
    width: 6.875,
    height: 6.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 32,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_10661_110843"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.898784 0 0 0 0 0.249038 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10661_110843"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10661_110843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner);
export default __webpack_public_path__ + "static/media/winner.7a38ed8658c84ef8c7f735676b886839.svg";
export { ForwardRef as ReactComponent };